import React from 'react';

import { ICampaignProps } from '@domain/interfaces/dashboard/AdsManager/Table/Campaign/ICampaign';
import { ICpm } from '@domain/interfaces/dashboard/AdsManager/AdSenseCampaigns/ISummaryReport';

import { numberFormatter } from '@helpers/masks';

import * as S from './styles';

const Cpm: React.FC<ICampaignProps> = ({ data }) => {
  const cpmData: ICpm = data;

  return (
    <S.Wrapper>
      <S.CpmAmount>{`R$ ${numberFormatter(cpmData.average_amount, 2)}`}</S.CpmAmount>
      <S.CpmLabel>Por 1.000 Impressões</S.CpmLabel>
    </S.Wrapper>
  );
};

export default Cpm;
